export const createInitialMapState = (initialMapState) => {
	if (initialMapState?.selectedHexagons) {
		return new window.Map(initialMapState.selectedHexagons);
	}
	return new window.Map();
};

export const applyMapSlotState = (mapObject, initialMapState, setSelectedHexagons) => {
	if (!mapObject || !initialMapState) return;
	
	// Set selections
	setSelectedHexagons(new window.Map(initialMapState.selectedHexagons || []));
	
	// Fly to saved position
	if (initialMapState.center && initialMapState.zoom) {
		mapObject.flyTo({
			center: initialMapState.center,
			zoom: initialMapState.zoom,
			essential: true
		});
	}
};

export const clearMapSlotState = (setSelectedHexagons) => {
	setSelectedHexagons(new window.Map());
};

export const restoreMapState = (mapObject, initialMapState, setSelectedHexagons) => {
	if (!mapObject) return;
	
	// Restore selections
	if (initialMapState?.selectedHexagons) {
		setSelectedHexagons(new window.Map(initialMapState.selectedHexagons));
	} else {
		setSelectedHexagons(new window.Map());
	}
	
	// Restore map position
	if (initialMapState?.center && initialMapState?.zoom) {
		mapObject.flyTo({
			center: initialMapState.center,
			zoom: initialMapState.zoom,
			essential: true
		});
	}
};

export const getCurrentMapState = (mapObject, selectedHexagons) => {
	if (!mapObject) return null;
	
	const center = mapObject.getCenter();
	const zoom = mapObject.getZoom();
	
	return {
		center: [center.lng, center.lat],
		zoom,
		selectedHexagons: Array.from(selectedHexagons.entries())
	};
};